import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

// Thin banner shown whenever the browser is offline, so users know the customer and
// invoice data on screen is saved (cached) data rather than live.
export default function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator === "undefined" ? true : navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); };
  }, []);

  if (online) return null;
  return (
    <div className="flex items-center justify-center gap-2 bg-amber-500 text-black text-sm font-semibold py-1.5 px-4" data-testid="offline-banner">
      <WifiOff size={15} />
      You're offline — showing saved data. Changes will sync when you reconnect.
    </div>
  );
}
